(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['underscore', 'torso/modules/Collection', './AppointmentModel', 'services/appointmentExtService'], factory);
  } else if (typeof exports === 'object') {
    // Node, CommonJS-like
    var appointmentExtService = require('./../urls').appointmentExtService;
    module.exports = factory(require('underscore'), require('backbone-torso/modules/Collection'), require('./AppointmentModel'), appointmentExtService);
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function (_, TorsoCollection, AppointmentModel, appointmentExtService) {
  'use strict';

  /**
   * Receives appointments from the AppointmentExtService which serves the AppointmentDTO resource
   * @class AppointmentCollection
   * @static
   * @extends Torso.Collection
   */
  return new (TorsoCollection.extend({
    model: AppointmentModel,
    url: appointmentExtService,
    fetchHttpAction: 'POST',
    fetchIdsByCriteria: function(criteria) {
      if (criteria.type === 'dataTable') {
        return $.ajax({
          url: _.result(this, 'url') + '/criteria/datatable',
          method: 'POST',
          contentType: 'application/json; charset=utf-8',
          dataType: 'json',
          data: JSON.stringify(criteria.tableParams),
          context: this
        });
      } else if (!_.isUndefined(criteria)) {
        return $.ajax({
          url: _.result(this, 'url') + '/criteria',
          method: 'POST',
          contentType: 'application/json; charset=utf-8',
          dataType: 'json',
          data: JSON.stringify(criteria),
          context: this
        });
      } else {
        throw 'Unsupported criteria';
      }
    },
    updateCollection: function(collection) {
      return $.ajax({
        url: appointmentExtService + '/batch',
        contentType: 'application/json',
        type: 'PUT',
        dataType: 'json',
        data: JSON.stringify(collection)
      });
    }
  }))();
}));
